// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportsTable_root__1n7zj","EmptyRow":"ReportsTable_EmptyRow__1xkP6","dataLoadingWrap":"ReportsTable_dataLoadingWrap__OqJ_M"};